import { render } from "./AiPortalModel.vue?vue&type=template&id=abe4eae0&scoped=true&ts=true"
import script from "./AiPortalModel.vue?vue&type=script&lang=ts"
export * from "./AiPortalModel.vue?vue&type=script&lang=ts"

import "./AiPortalModel.vue?vue&type=style&index=0&id=abe4eae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe4eae0"]])

export default __exports__